<p-fieldset legend="Ehrenamt" [formGroup]="ehrenamtForm">
  <div class="flex flex-col w-full gap-4 pt-2">
    <p-floatlabel class="w-full" variant="on">
      <input id="institution" class="w-full" type="text" pInputText appTrTrim [formControl]="ehrenamtForm.controls.institution" />
      <label for="institution">Institution*</label>
    </p-floatlabel>

    <p-floatlabel variant="on">
      <textarea id="taetigkeit" pTextarea rows="5" [formControl]="ehrenamtForm.controls.taetigkeit"></textarea>
      <label for="taetigkeit">Tätigkeit</label>
      <div class="flex justify-end">
        <small
          [ngClass]="
            ehrenamtForm.controls.taetigkeit.errors && this.ehrenamtForm.controls.taetigkeit.errors['maxlength']
              ? 'form-hint-text-error'
              : 'form-hint-text'
          "
        >
          {{ taetigkeitCount }}/{{ taetigkeitMaxLength }}
        </small>
      </div>
    </p-floatlabel>

    <app-date-range [vonDate]="ehrenamtForm.controls.von" [bisDate]="ehrenamtForm.controls.bis"></app-date-range>
  </div>
  <div class="flex flex-row justify-end items-end pt-2">
    <p-button icon="pi-trash" outlined label="Löschen" severity="danger" (click)="remove.emit()"></p-button>
  </div>
</p-fieldset>
